import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import photo from "../../../media/img/companyInfo/default.png";
import AlbaEspejo from "../../../media/img/companyInfo/fotosEquipo/AlbaEspejo.jpg";
import DanielRodríguezMagro from "../../../media/img/companyInfo/fotosEquipo/DanielRodríguezMagro.jpg";
import LuisRodríguezGarcía from "../../../media/img/companyInfo/fotosEquipo/LuisRodríguezGarcía.jpg";
import "./teamMember.scss"

const team = [
    {
        id: 1,
        key: "m1",
        name: "Daniel Rodríguez",
        photo: DanielRodríguezMagro,
    },
    {
        id: 2,
        key: "m2",
        name: "Luis Rodríguez",
        photo: LuisRodríguezGarcía,
    },
    {
        id: 3,
        key: "m3",
        name: "Alba Espejo",
        photo: AlbaEspejo,
    },
    {
        id: 4,
        key: "m4",
        name: "Carmen Rodríguez",
        photo: photo,
    },
    {
        id: 5,
        key: "m5",
        name: "Javier Morales",
        photo: photo,
    },
    {
        id: 6,
        key: "m6",
        name: "Laura Fernández",
        photo: photo,
    },
    {
        id: 7,
        key: "m7",
        name: "Carlos Méndez",
        photo: photo,
    },
    {
        id: 8,
        key: "m8",
        name: "Sofía Navarro",
        photo: photo,
    }
];

const TeamMember = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div className='companyInfo__teamMember'>
            <section className='teamMember'>
                <div className='teamMember__header'>
                    <h1 className='teamMember__title content__title-backgroundDark'>{t('about.team.title')}</h1>
                    <div ref={el => lineRefs.current[0] = el} className="content__title-line" />
                    <p className='teamMember__subtitle content__text-title-backgroundDark'>
                        {t('about.team.subtitle')}
                    </p>
                </div>
                <div className='teamMember__grid'>
                    {team.map((person) => (
                        <div key={person.id} className={`teamMember__card-container ${person.photo === photo ? "flipped" : ""}`}>
                            <div className='teamMember__card-flipper'>
                                <div className='teamMember__card-front'>
                                    <div className='teamMember__img-container'>
                                        <img className='teamMember__img' src={person.photo} alt={person.name} />
                                    </div>
                                </div>
                                <div className='teamMember__card-back'>
                                    <p className='teamMember__position'>{t(`about.team.members.${person.key}.position`)}</p>
                                    <h3 className='teamMember__name'>{person.name}</h3>
                                    <p className='teamMember__rol-descrition'>{t(`about.team.members.${person.key}.desc`)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}

export default TeamMember;